import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealerDocumentationsQueryKeys } from "modules/DealerDocumentations/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DealerDocumentation } from "models";

export const useUpdateDocumentationMutation = () =>
  useTypedMutation<DealerDocumentation, void>({
    mutationFn: async payload => (await ApiInstance.post("/documentations/update", payload, ENV.dealerBaseURL)).data,
    onSuccess: payload => {
      const dealerDocumentations = typedQueryClient.getQueryData(DealerDocumentationsQueryKeys.list);
      if (!dealerDocumentations) return;

      const docIdx = dealerDocumentations.findIndex(({ id }) => id === payload.id);
      if (docIdx === -1) return;

      typedQueryClient.setQueryData(DealerDocumentationsQueryKeys.list, dealerDocumentations.with(docIdx, { ...dealerDocumentations[docIdx], ...payload }));
    }
  });
